import { render, staticRenderFns } from "./PHPStatus.vue?vue&type=template&id=66e62b2e&"
import script from "./PHPStatus.vue?vue&type=script&lang=js&"
export * from "./PHPStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports